module.exports = __webpack_public_path__ + "img/sandos4u-logo.png";